import { useState } from 'react';
import LoadingState from 'components/LoadingState';
import { MediaModel } from 'lib/model/objects/mediaModel';
import { ColumnService } from 'lib/services/directory';
import { Alert } from 'lib/components/Alert';
import { Media } from 'lib/types';
import { useMediaLibrary } from './clipArtHelpers';
import MediaEditorModal from './MediaEditorModal';
import MediaGrid from './MediaGrid';

type ClipArtLibraryProps = {
  organizationId: string;
  folder: Media['folder'];
  uploads?: string[];
};

function ClipArtLibrary({
  organizationId,
  folder,
  uploads
}: ClipArtLibraryProps) {
  const [selectedMedia, setSelectedMedia] = useState<MediaModel | null>(null);
  const {
    value: mediaList,
    isLoading,
    isError,
    invalidateData
  } = useMediaLibrary({ organizationId, folder, uploads });

  if (isError) {
    return (
      <Alert
        id="clip-art-error"
        title="Loading failure"
        description="Failed to load clip art library. If the error persists, please contact Column support."
        status="error"
      />
    );
  }

  if (isLoading) {
    return (
      <LoadingState
        context={{
          location: window.location.pathname,
          tags: { organizationId },
          service: ColumnService.FILE_STORAGE
        }}
      />
    );
  }

  return (
    <>
      {mediaList && (
        <div
          className="overflow-scroll"
          style={{ maxHeight: mediaList?.length ? '40vh' : 0 }}
        >
          <MediaGrid mediaList={mediaList} onClick={setSelectedMedia} />
        </div>
      )}
      {selectedMedia && (
        <MediaEditorModal
          media={selectedMedia}
          onClose={() => setSelectedMedia(null)}
          onEdit={invalidateData}
        />
      )}
    </>
  );
}

export default ClipArtLibrary;
